var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 1.89386C19.2647 2.21541 18.4734 2.43195 17.6435 2.52973C18.4908 2.02969 19.1414 1.23829 19.4474 0.295298C18.6554 0.75859 17.7761 1.09392 16.8422 1.2757C16.0936 0.490854 15.0263 0 13.8471 0C11.5812 0 9.74401 1.80855 9.74401 4.03904C9.74401 4.35534 9.78068 4.66377 9.85068 4.95972C6.44024 4.79173 3.41711 3.18333 1.39324 0.739561C1.03993 1.33607 0.837944 2.0297 0.837944 2.76992C0.837944 4.17095 1.56123 5.40727 2.66316 6.13174C1.98987 6.11074 1.35791 5.92897 0.803945 5.62645V5.67697C0.803945 7.63448 2.21918 9.26651 4.09506 9.63859C3.75108 9.73046 3.38844 9.78033 3.01447 9.78033C2.74982 9.78033 2.4925 9.75473 2.24185 9.70749C2.76381 11.3119 4.27971 12.48 6.07493 12.5128C4.67102 13.5956 2.90181 14.242 0.979267 14.242C0.647289 14.242 0.320645 14.2229 0 14.1849C1.81588 15.3306 3.9724 16 6.28958 16C13.8364 16 17.9635 9.84529 17.9635 4.50824C17.9635 4.33303 17.9601 4.15848 17.9515 3.98589C18.7541 3.41498 19.45 2.70363 20 1.89386Z",
    fill: "#4776E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.503896b0ed9059d19515262662184d41.svg";
export { ForwardRef as ReactComponent };